import { NavLink, Link } from 'react-router-dom';
import './Header.css';

export default function Header() {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="site-header__brand" aria-label="Sistemas Administrativos S.A.">
          <img
            className="site-header__brand-logo"
            src="/images/desktop/header-logo.png"
            alt=""
            aria-hidden="true"
          />
          <div className="site-header__brand-text">
            <span className="site-header__brand-line1">SISTEMAS</span>
            <span className="site-header__brand-line2">ADMINISTRATIVOS S.A.</span>
          </div>
        </Link>

        <nav className="site-header__nav" aria-label="Navegación principal">
          <NavLink to="/quienes-somos" className={({ isActive }) => `site-header__link${isActive ? ' is-active' : ''}`}>
            Quiénes Somos
          </NavLink>
          <NavLink to="/apps" className={({ isActive }) => `site-header__link${isActive ? ' is-active' : ''}`}>
            Apps
          </NavLink>
        </nav>

        <Link to="/#contacto" className="site-header__cta">
          Empezá Gratis <span aria-hidden="true">→</span>
        </Link>
      </div>
    </header>
  );
}
